import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('configurationSettings/getData', async (params) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Configuration/GetTableSummary', params, {mode:'cors'})
      
      return {
         params,
         data: response.data
      }
   })

   export const addConfiguration = createAsyncThunk('configurationSettings/addConfiguration', async (Configuration) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Configuration/Create', Configuration, {mode:'cors'})
      
      return response
   })

   export const editConfiguration  = createAsyncThunk('configurationSettings/editConfiguration', async (Edit) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Configuration/Update', Edit, {mode:'cors'})
      
      return response
   })

   export const getConfigurationData = createAsyncThunk('configurationSettings/getConfigurationData', async (params) => {
      
      const response = await axios.post('https://api.zasway.com:8443/Configuration/GetConfigurationData', params, {mode:'cors'})
      
      return {
         params,
         data: response.data
      }
   })

export const configurationSlice = createSlice({
   name: 'configurationSettings',
   initialState: {
      configurationEditData: [],
      configurationUserData: []
   },
   reducers: {},
   extraReducers: builder => {
     builder

      .addCase(getData.fulfilled, (state, action) => {
         state.ConfigEditData = action.payload.data
      })

      .addCase(editConfiguration.fulfilled, (state, action) => {
         state.data = action.payload.data
      })

      .addCase(getConfigurationData.fulfilled, (state, action) => {
         state.configurationUserData = action.payload.data
      })
   }
})
   
export default configurationSlice.reducer